import oauth2 from '../oauth2Api';

// localStorage keeps strings only, so a token written from a response that carried none reads
// back as "undefined" (or "null"). Sending that as `Bearer undefined` or `refresh_token=undefined`
// can never succeed, so those values count as no token at all.
const UNUSABLE = ['', 'undefined', 'null'];

export function storedToken(key) {
  const value = localStorage.getItem(key);
  return value && !UNUSABLE.includes(value) ? value : null;
}

export function accessToken() {
  return storedToken('jwtToken');
}

// Every request that comes back 401 while a refresh is already on the wire waits for that one
// refresh. A tab returning after the tokens expired fires several calls at once, and each used to
// start its own refresh with the same token.
let pending = null;

export function refreshSession() {
  if (!pending) {
    pending = exchangeRefreshToken().finally(() => {
      pending = null;
    });
  }
  return pending;
}

async function exchangeRefreshToken() {
  const refreshToken = storedToken('jwtRefreshToken');
  if (!refreshToken) {
    signOut();
    return false;
  }
  console.log('Refreshing token... ');
  try {
    const response = await oauth2.post(
      '/token',
      new URLSearchParams({ refresh_token: refreshToken, grant_type: 'refresh_token' }).toString()
    );
    const tokens = (response && response.data) || {};
    if (!tokens.access_token || !tokens.refresh_token) {
      console.error('Refresh answered without tokens');
      signOut();
      return false;
    }
    localStorage.setItem('jwtToken', tokens.access_token);
    localStorage.setItem('jwtRefreshToken', tokens.refresh_token);
    return true;
  } catch (error) {
    // An expired refresh token is how a session normally ends, so this is information, not an error.
    console.info(`Session could not be refreshed (status ${error && error.status}); signing out`);
    signOut();
    return false;
  }
}

// Send the operator to the sign-in page once. This used to reload the whole app at `/`, which
// booted every authenticated call again, and when the stored tokens could not be refreshed that
// reload repeated for ever. Moving to #/login changes the route only: the sign-in page makes no
// authenticated calls, so nothing comes back 401 to start another round.
export function signOut() {
  localStorage.removeItem('jwtToken');
  localStorage.removeItem('jwtRefreshToken');
  if (window.location.hash !== '#/login') {
    window.location.hash = '#/login';
  }
}
